import { type StripeAddressElementChangeEvent } from '@stripe/stripe-js';

import { AddressElementWrapper } from './steps/AddressElementWrapper';
import { PaymentElementWrapper } from './steps/PaymentElementWrapper';
import { Wizard, type WizardStepComponent } from './Wizard';

export type AddressElementValue = StripeAddressElementChangeEvent['value'];

export type StripeData = {
  address?: AddressElementValue;
};
enum Step {
  ADDRESS = 'ADDRESS',
  PAYMENT_DETAILS = 'PAYMENT_DETAILS',
}

const stepComponents = {
  [Step.ADDRESS]: AddressElementWrapper,
  [Step.PAYMENT_DETAILS]: PaymentElementWrapper,
} satisfies Record<Step, WizardStepComponent<StripeData>>;

export const StripeWizard = () => (
  <Wizard<StripeData, Step> stepComponents={stepComponents} />
);
